<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a class="btn btn-primary" (click)="volver()">
            Volver
          </a>
        </div>
        <h3 class="page-title">Editar | Institucional | {{nombre_institucional}}</h3>
      </div>
    </div>
  </div>

  <form [formGroup]="formularioRegistro" id="formularioReprogrma">
    <!------ datos_institucional ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Información Institucional</h5>
        </div>
      </div>
      <div class="row g-3">
        <!--Fila 1-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Rol <span class="text-danger">*</span></label>
            <select class="form-control" id='rol' formControlName="frm_id_rol" (change)="valida($event.target)" required>
              <option *ngFor="let a of rol;" value="{{a.id_rol}}">{{a.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6" [style.display]="this.validaTipoRol ? 'block' : 'none'">
            <label class="form-label">Tipo de formador <span class="text-danger">*</span></label>
            <select class="form-control" id='tipo_formador' formControlName="frm_id_tipo_formador">
              <option *ngFor="let a of tipo_formador;" value="{{a.id_tipo_formador}}">{{a.nombre}}</option>
            </select>
          </div>
        </div>
        <!--Fila 2-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Contraseña <span class="text-danger">*</span></label>
            <div class="input-group">
              <input type='password' id='contrasena' formControlName="frm_contrasena" class='form-control'>
              <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(1)">
                <span class="input-group-text">
                    ver
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Repita contraseña <span class="text-danger">*</span></label>
            <div class="input-group">
              <input type='password' id='confirma_contrasena' formControlName="frm_confirma_contrasena" class='form-control'>
              <div class="input-group-append" style="cursor: pointer;" id="ver_pass" (click)="ver_pass(2)">
                <span class="input-group-text">
                    ver
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--Fila 3-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Gerencia/Liceo <span class="text-danger">*</span></label>
            <select class="form-control" id='grado_instruccion' formControlName="frm_id_gerencia" required>
              <option *ngFor="let a of gerencias;" value="{{a.id_gerencia}}">{{a.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Cargo <span class="text-danger">*</span></label>
            <select class="form-control" id='ultimo_ano' formControlName="frm_id_cargo" required>
              <option *ngFor="let a of cargo;" value="{{a.id_cargo}}">{{a.nombre}}</option>
            </select>
          </div>
        </div>
        <!--Fila 4-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Fecha de ingreso <span class="text-danger">*</span></label>
            <div class="input-group">
              <input class="form-control" placeholder="Fecha de ingreso" formControlName="frm_fecha_ingreso" [readOnly]="true" #fch="ngbDatepicker" ngbDatepicker>
              <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fch.toggle()" type="button"></button>
            </div>

          </div>
          <div class="col-md-6">
            <label for='simpleinput' class='form-label'>Correo electrónico <span class="text-danger">*</span></label>
            <input type='text' class='form-control' formControlName="frm_correo" id='correo' required>
          </div>
        </div>
      </div>
    </div>


    <!------ datos_personales ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Información Personal</h5>
        </div>
      </div>
      <div class="row g-3">
        <!--Fila 1-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Nombre(s) <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="frm_nombre" id="nombre" placeholder="Nombre(s)">
          </div>
          <div class="col-md-6">
            <label class="form-label">Apellido(s) <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="frm_apellido" id="apellido"  placeholder="Apellidos(s)">
          </div>
        </div>
        <!--Fila 2-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Identificación</label>
            <div class="row" style="--bs-gutter-x: 0px;">
              <div class="col-3">
                <input class="form-control" type="text" id="nro_doc" formControlName="frm_nro_doc" readonly>
              </div>
              <div class="col-9">
                <input class="form-control" type="text" id="documento" formControlName="frm_identificacion" readonly>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">Fecha de nacimiento <span class="text-danger">*</span></label>
            <div class="input-group">
              <input class="form-control" placeholder="Fecha de nacimiento" formControlName="frm_fecha_nacimiento" [readOnly]="true" #fch2="ngbDatepicker" ngbDatepicker>
              <button class="btn btn-outline-secondary bi bi-calendar3 calendar" (click)="fch2.toggle()" type="button"></button>
            </div>
          </div>
        </div>
        <!--Fila 3-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Nivel académico <span class="text-danger">*</span></label>
            <select class="form-control" id='grado_instruccion' formControlName="frm_nivel_academico">
              <option *ngFor="let a of grado_instruccion;" value="{{a.id_grado_instruccion}}">{{a.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Estado civil <span class="text-danger">*</span></label>
            <select class="form-select" id='edo_civil' formControlName="frm_edo_civil">
              <option *ngFor="let a of estado_civil;" value="{{a.id_estado_civil}}">{{a.nombre}}</option>
            </select>
          </div>
        </div>
        <!--Fila 4-->
        <div class="row mt-6">
          <div class="col-md-6">
            <label class="form-label">Genero <span class="text-danger">*</span></label>
            <select class="form-select" id="id_sexo" formControlName="frm_genero">
              <option *ngFor="let a of sexo;" value="{{a.id_sexo}}">{{a.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Carnet de la patria <span class="text-danger">*</span></label>
            <input type='text' id='id_carnet_patria' formControlName="frm_carnet_patria" class='form-control' mask="9999999999">
          </div>
        </div>
      </div>
    </div>



    <!------datos_contacto ------>
    <hr class="text-dark">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
          <h5>Datos de Contacto</h5>
        </div>
      </div>
      <div class="row g-3">
        <!--Fila 1-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Número de teléfono<span class="text-danger">*</span></label>
            <input type="text" formControlName="frm_telefono" id='tlf_local_movil' class="form-control" mask="99999999999" required>
          </div>
          <div class="col-md-6">
            <label for='simpleinput' class='form-label'>Correo alternativo<span class="text-danger">*</span></label>
            <input type='text' class='form-control' formControlName="frm_correo_alternativo" id='correo' required>
          </div>
        </div>
        <!--Fila 2-->
        <div class="row mt-4">
          <div class="col-md-6">
            <label class="form-label">Estado <span class="text-danger">*</span></label>
            <select class="form-control" formControlName="frm_estado" id='estado' required>
              <option value="">--SELECCIONE--</option>
              <option *ngFor="let a of estado;" value="{{a.id_estado}}">{{a.nombre}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">Dirección de habitación<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="frm_dirreccion" id="direccion"  placeholder="Dirección" required>
          </div>
        </div>
      </div>
    </div>




    <!------ Expedientes ------>
    <ng-container *ngIf="id_rol == 11">
      <hr class="text-dark">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-12">
            <h5>Expediente Digital</h5>
          </div>
        </div>
        <div class="row g-3 container-fluid">
          <ol>
            <li class="mb-2">
              <div class="row">
                <div class="col-md-6 mt-3">
                  Componente docente.&nbsp;&nbsp;
                  <label for="fileNotas" class="label-file btn btn-sm btn-primary">{{txtComponente}}</label>
                  <input id="fileNotas" style="display:none;" type="file" (change)="cambia(1, $event)" accept=".pdf">
                </div>
                <div class="col-6" *ngIf="valComponente">
                  <embed id="imgNotas" [src]="valComponente" type="application/pdf" width="55%" height="200px"/>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="row">
                <div class="col-md-6 mt-3">
                  Sintesis curricular.&nbsp;&nbsp;
                  <label for="fileComprobante" class="label-file btn btn-sm btn-primary">{{txtSintesis}}</label>
                  <input id="fileComprobante" style="display:none;" type="file" (change)="cambia(2, $event)" accept=".pdf">
                </div>
                <div class="col-6" *ngIf="valSintesis">
                  <embed id="imgComprobante" [src]="valSintesis" type="application/pdf" width="55%" height="200px"/>
                </div>
              </div>
            </li>
            <li class="mb-2">
              <div class="row">
                <div class="col-md-6 mt-3">
                  Cedula.&nbsp;&nbsp;
                  <label for="fileFotografia" class="label-file btn btn-sm btn-primary">{{txtCedula}}</label>
                  <input id="fileFotografia" style="display:none;" type="file" (change)="cambia(3, $event)" accept=".pdf">
                </div>
                <div class="col-6" *ngIf="valCedula">
                  <embed id="imgFotografia" [src]="valCedula" type="application/pdf" width="55%" height="200px"/>
                </div>
              </div>
            </li>
          </ol>
        </div>




      </div>
    </ng-container>


    <!------ Editar Estudiante ------>
    <hr class="text-dark">
    <div class="col-12 text-center">
      <button type="button" class="btn btn-lg btn-primary" (click)="guardar_todo()">Editar</button>
    </div>
  </form>


</div>

<div style="margin-bottom: 300px;"></div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
